import React from "react";

const Parametros = ({ numSet, selectedSet, onChangeSet }) => {
  // Função para estilizar abas (mesmo padrão do relatório de fundamentos)
  const tabClass = (active) =>
    `w-[80px] h-[30px] rounded-t-md flex items-center justify-center text-sm font-medium border-b-2 ${
      active
        ? "border-blue-600 text-blue-700 bg-white"
        : "border-grey-200 text-gray-500 bg-white hover:border-blue-200"
    }`;

  return (
    <div className="">
      {/* Abas de Sets */}
      <span className="text-xs text-gray-500 ">Sets:</span>
      <div className="flex mb-2  ">
        {[...Array(Number(numSet)).keys()].map((i) => {
          const setNum = String(i + 1);
          const isSelected = selectedSet === setNum;

          return (
            <button
              key={setNum}
              onClick={() => onChangeSet(setNum)}
              className={tabClass(isSelected)}
            >
              {setNum}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Parametros;
